import { render, staticRenderFns } from "./SupplierManage.vue?vue&type=template&id=74542262&scoped=true&"
import script from "./SupplierManage.vue?vue&type=script&lang=js&"
export * from "./SupplierManage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierManage.vue?vue&type=style&index=0&id=74542262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74542262",
  null
  
)

export default component.exports